import React from 'react';
import { useMutation } from 'react-query';
import { receiptApi } from 'services/apis';
import {
  CreateReceiptPayloadDto,
  PremiumScheduleAllocationDto,
  SyncReceiptSettlementExchangeRatePayloadDto,
} from 'libs/pinnacle-sdk';
import { ReceiptForm } from '../receipt-form';

const CreateReceiptForm: React.FC = () => {
  const createReceiptMutation = useMutation<
    void,
    Error,
    {
      receipt: CreateReceiptPayloadDto;
      fileIds: string[];
      premiumScheduleAllocations?: PremiumScheduleAllocationDto[];
      receiptSettlementExchangeRates?: SyncReceiptSettlementExchangeRatePayloadDto[];
    }
  >(
    async ({
      receipt,
      fileIds,
      premiumScheduleAllocations,
      receiptSettlementExchangeRates,
    }) => {
      await receiptApi.createReceipt({
        createReceiptPayloadDto: {
          ...receipt,
          fileIds,
          premiumScheduleAllocations,
          receiptSettlementExchangeRates,
        },
      });
    }
  );

  return (
    <ReceiptForm
      mode="create"
      onSubmit={createReceiptMutation.mutateAsync}
      isLoading={createReceiptMutation.isLoading}
    />
  );
};

export default CreateReceiptForm;
